import { render, staticRenderFns } from "./Cookies-en.vue?vue&type=template&id=33597212&"
import script from "./Cookies-en.vue?vue&type=script&lang=js&"
export * from "./Cookies-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\botaliberec-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33597212')) {
      api.createRecord('33597212', component.options)
    } else {
      api.reload('33597212', component.options)
    }
    module.hot.accept("./Cookies-en.vue?vue&type=template&id=33597212&", function () {
      api.rerender('33597212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookies/Cookies-en.vue"
export default component.exports